import { reducerWithInitialState } from 'typescript-fsa-reducers';

type ShippingDateWithOrder = {
    full?: string;
    semi?: string;
};

export interface ShippingDateReducer {
    kinteki: ShippingDateWithOrder;
    enteki: ShippingDateWithOrder;
    makiwara: ShippingDateWithOrder;
}

const initState: ShippingDateReducer = {
    kinteki: {},
    enteki: {},
    makiwara: {},
};

export const shippingDateReducer = reducerWithInitialState(initState);
